<article class="placeholder-container">
  <p class="message"> 
    {{ label | translate }} 
  </p>
  <p class="submessage" *ngIf="displaySub"> 
    {{ "common.no-results-sub" | translate }} 
  </p>
</article>